export default function DOM_CDATA() {
  return (
    <div>
      <h1>DOM_CDATA</h1>
      <p>This is the DOM_CDATA component.</p>
    </div>
  );
}